import { ToPartialMatchOptions } from 'Shared/utilities/MapDiscriminatedUnion';
import { ContingentBeneficiary } from 'ApplicationEntry/models/ContingentBeneficiary';
import * as I from 'immutable';

export class InvalidContingentBeneficiaryList {
  public readonly key = 'InvalidContingentBeneficiaryList';

  constructor(public readonly contingentBeneficiaryList: I.List<ContingentBeneficiary>) { }
}

export class ValidContingentBeneficiaryList {
  public static create(contingentBeneficiaryList: I.List<ContingentBeneficiary>) {
    const contingentBeneficiaryListArrayLength = contingentBeneficiaryList.size;
    const haveAtLeastOneContingentBeneficiary = contingentBeneficiaryListArrayLength > 0;

    return haveAtLeastOneContingentBeneficiary ? new ValidContingentBeneficiaryList(contingentBeneficiaryList) : new InvalidContingentBeneficiaryList(contingentBeneficiaryList);
  }

  public readonly key = 'ValidContingentBeneficiaryList';
  private constructor(public readonly contingentBeneficiaryList: I.List<ContingentBeneficiary>) { }
}

export type ContingentBeneficiaryList = InvalidContingentBeneficiaryList | ValidContingentBeneficiaryList;

export type ContingentBeneficiaryListOptions<TReturn> = ToPartialMatchOptions<ContingentBeneficiaryList, 'key', TReturn>;

export const matchContingentBeneficiaryList = <TReturn>(options: ContingentBeneficiaryListOptions<TReturn>) => (app: ContingentBeneficiaryList): TReturn => {
  switch (app.key) {
    case 'InvalidContingentBeneficiaryList':
      return options.InvalidContingentBeneficiaryList ? options.InvalidContingentBeneficiaryList(app) : options.default(app);
    case 'ValidContingentBeneficiaryList':
      return options.ValidContingentBeneficiaryList ? options.ValidContingentBeneficiaryList(app) : options.default(app);
  }
};

export const addContingentBeneficiary = (contingentBeneficiary: I.List<ContingentBeneficiary>) => (contingentBeneficiaryList: I.List<ContingentBeneficiary>) => {
  const existingList: I.List<ContingentBeneficiary> = contingentBeneficiaryList;
  const newContingentBeneficiaryList = existingList.concat(contingentBeneficiary);

  return ValidContingentBeneficiaryList.create(newContingentBeneficiaryList);
};

export const removeContingentBeneficiary = (index: number) => (contingentBeneficiaryList: I.List<ContingentBeneficiary>) => {
  const existingList: I.List<ContingentBeneficiary> = contingentBeneficiaryList;
  const newContingentBeneficiaryList = existingList.delete(index);

  return ValidContingentBeneficiaryList.create(newContingentBeneficiaryList);
};

export const updateContingentBeneficiary = (contingentBeneficiary: ContingentBeneficiary, index: number) => (contingentBeneficiaryList: I.List<ContingentBeneficiary>) => {
  const existingList: I.List<ContingentBeneficiary> = contingentBeneficiaryList;
  let newContingentBeneficiaryList: I.List<ContingentBeneficiary> = existingList;

  newContingentBeneficiaryList = existingList.splice(index, 1, contingentBeneficiary);

  return ValidContingentBeneficiaryList.create(newContingentBeneficiaryList);
};

export const EmptyContingentBeneficiaryList = new InvalidContingentBeneficiaryList(I.List<ContingentBeneficiary>());